/**
 * RGM Contests · Phase 1 — Admin Judges Table.
 * Presentational: shows completion progress per judge.
 */
import React from "react";
import { optimizeImage } from "@/lib/mediaUrls";

export default function JudgesTable({ judges = [], disabled = false, onRemove }) {
  return (
    <div className="space-y-1" data-testid="judges-table">
      {judges.length === 0 && (
        <p className="text-[11px] text-gray-500" data-testid="judges-empty">No judges assigned.</p>
      )}
      {judges.map((j) => {
        const u = j.user || {};
        return (
          <div key={j.assignment_id} className="flex items-center gap-2 rounded border border-white/10 bg-black/30 p-2" data-testid={`judge-row-${j.judge_user_id}`}>
            {u.profile_photo && <img src={optimizeImage(u.profile_photo, 'avatar')} alt="" className="w-6 h-6 rounded-full object-cover" />}
            <span className="flex-1 truncate">
              <span className="text-xs font-bold text-white">{u.artist_name || u.name || j.judge_user_id}</span>
              {u.handle && <span className="text-[10px] text-gray-500 block">@{u.handle}</span>}
            </span>
            <span className="text-[10px] tabular-nums text-gray-300" data-testid={`judge-progress-${j.judge_user_id}`}>
              {j.submitted}/{j.assigned_count} · {j.completion_pct}%
            </span>
            <span className={`text-[9px] px-1.5 py-0.5 rounded ${j.status === "active" ? "bg-emerald-500/20 text-emerald-200" : "bg-gray-500/20 text-gray-300"}`}>
              {j.status}
            </span>
            {j.status === "active" && (
              <button
                type="button" onClick={() => onRemove?.(j.judge_user_id)} disabled={disabled}
                className="text-[10px] text-red-300 hover:text-red-200 disabled:opacity-30"
                data-testid={`judge-remove-${j.judge_user_id}`}
              >Remove</button>
            )}
          </div>
        );
      })}
    </div>
  );
}
